export default __webpack_public_path__ + "static/media/rosette.5ff7a033.png";